module.exports = __webpack_public_path__ + "media/images/right_arrow-b736696fc6695c6d40218aed0566b79e.png";